import { render, staticRenderFns } from "./EditPrivilege.page.vue?vue&type=template&id=011a9acc&"
import script from "./EditPrivilege.page.vue?vue&type=script&lang=js&"
export * from "./EditPrivilege.page.vue?vue&type=script&lang=js&"
import style0 from "./EditPrivilege.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports